import React, { useState } from "react";
import CategoryList from "./CategoryList";
import SupplierList from "./SupplierList";
import Unit from "./Unit";
import Company from "./Company";
import MedicineGroup from "./MedicineGroup";
import PageHeading from "../../PageHeading";

const PharmacyList = () => {
  const [activeTab, setActiveTab] = useState("Medicine Category");

  const tabs = [
    {
      name: "Medicine Category",
      content: (
        <div className="tab-content">
          <CategoryList />
        </div>
      ),
    },
    {
      name: "Supplier",
      content: (
        <div className="tab-content">
          <SupplierList />
        </div>
      ),
    },
    {
      name: "Unit",
      content: (
        <div className="tab-content">
          <Unit />
        </div>
      ),
    },
    {
      name: "Company",
      content: (
        <div className="tab-content">
          <Company />
        </div>
      ),
    },
    {
      name: "Medicine Group",
      content: (
        <div className="tab-content">
          <MedicineGroup />
        </div>
      ),
    },
  ];

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Pharmacy"},
    { label: "Pharmacy Config" },
];

  return (
    <div>
      <div className="print-hidden">
        <PageHeading title="Medicine Category List" breadcrumbs={breadcrumbs} />
      </div>
      <div className="pharmacy-container flex flex-col xl:flex-row gap-5 items-start">
        {/* Left-side tabs */}
        <div className="tab-list flex w-full flex-col sm:flex-row xl:flex-col xl:w-64 shrink-0 bg-white border-r border-gray-200 shadow-sm rounded-lg overflow-hidden">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button w-full text-center xl:text-left py-3 px-2 xl:px-4 text-xs xl:text-sm font-medium text-gray-700 border-b border-gray-200 transition-colors duration-200 ${
                activeTab === tab.name
                  ? "bg-gray-100 text-blue-600 font-semibold"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-area flex-grow w-full">
          {tabs.find((tab) => tab.name === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};

export default PharmacyList;
